import { IInterval } from "../chart/types";

export function formatDateInterval(interval: IInterval, date: Date): string {
  if (interval === "hour" || interval === "minute") {
    return new Intl.DateTimeFormat("ko-KR", {
      hour: "2-digit",
      minute: "2-digit",
    }).format(date);
  }

  if (interval === "month") {
    return new Intl.DateTimeFormat("ko-KR", { month: "short" }).format(date);
  }

  if (interval === "day") {
    return new Intl.DateTimeFormat("ko-KR", {
      weekday: "short",
      day: "2-digit",
      month: "2-digit",
    }).format(date);
  }

  if (interval === "second") {
    return new Intl.DateTimeFormat("ko-KR", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(date);
  }

  return date.toISOString();
}

export function useFormatDateInterval(interval: IInterval) {
  return (date: Date | string) =>
    formatDateInterval(
      interval,
      typeof date === "string" ? new Date(date) : date,
    );
}

export function useSecondsToTime() {
  return (totalSeconds: number) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const timeParts: string[] = [];

    if (hours > 0) {
      timeParts.push(`${hours}시간`);
    }

    if (minutes > 0) {
      timeParts.push(`${minutes}분`);
    }

    timeParts.push(`${seconds}초`);

    return timeParts.join(" ");
  };
}
